var _defs, _rect, _circle, _circle2, _circle3, _path, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLedMirrors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 320",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lm-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FBF5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5EAD4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "lm-glow",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#DDB65C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "90%",
    stopColor: "#DDB65C",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDB65C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "lm-mirror",
    cx: "35%",
    cy: "30%",
    r: "75%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F3FAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#CFE8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9EC9C5"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 320,
    fill: "url(#lm-bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 160,
    r: 118,
    fill: "url(#lm-glow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 160,
    r: 95,
    fill: "none",
    stroke: "#DDB65C",
    strokeWidth: 6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 160,
    r: 86,
    fill: "url(#lm-mirror)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 100 Q170 140 155 210",
    stroke: "#ffffff",
    strokeWidth: 10,
    opacity: 0.55,
    fill: "none",
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#F5E8C4",
    strokeWidth: 3,
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 62,
    x2: 200,
    y2: 72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 248,
    x2: 200,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102,
    y1: 160,
    x2: 112,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288,
    y1: 160,
    x2: 298,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132,
    y1: 92,
    x2: 139,
    y2: 99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261,
    y1: 221,
    x2: 268,
    y2: 228
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268,
    y1: 92,
    x2: 261,
    y2: 99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139,
    y1: 221,
    x2: 132,
    y2: 228
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 298,
    textAnchor: "middle",
    fontFamily: "Georgia, serif",
    fontSize: 14,
    fill: "#4E3F37",
    letterSpacing: 1
  }, "LED Mirrors")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedMirrors);
export default __webpack_public_path__ + "static/media/led-mirrors.fd7a722b8b54e16fea4ca9e9c2fbaf8a.svg";
export { ForwardRef as ReactComponent };